import StyledTypo from '@tmh-website/styles/typo';
import { ButtonThemeColor, StyledButton, buttonThemes } from '@tmh-website/ui/Button';
import { ButtonUiTextProps } from '@tmh-website/ui/ButtonUiText';
import styled, { css } from 'styled-components';

export interface ContainerProps {
  $themeColor: ButtonThemeColor;
  $isLoading?: ButtonUiTextProps['isLoading'];
  $fullWidth?: ButtonUiTextProps['fullWidth'];
  $isSmall: ButtonUiTextProps['isSmall'];
  ref?: any;
}

export const Container = styled.div<ContainerProps>`
  ${StyledTypo.uiTextCss};
  ${StyledButton.ButtonBase};
  position: relative;
  z-index: 1;
  width: ${props => (props.$fullWidth ? '100%' : 'auto')};
  padding: ${props => (props.$isSmall ? props.theme.btnSmallPadding : props.theme.btnPaddingMobile)};
  overflow: hidden;
  color: ${props => props.theme.color[buttonThemes[props.$themeColor].text]};
  cursor: pointer;
  background-color: ${props => props.theme.color[buttonThemes[props.$themeColor].background.normal]};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  transition: ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.xl.up}) {
    padding: ${props => (props.$isSmall ? props.theme.btnSmallPadding : props.theme.btnPadding)};
  }

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    color: ${props => props.theme.color[buttonThemes[props.$themeColor].text]};
    text-decoration: none;
    background-color: ${props => props.theme.color[buttonThemes[props.$themeColor].background.hover]};
  }

  &:active {
    background-color: ${props => props.theme.color[buttonThemes[props.$themeColor].background.active]};
  }

  ${props =>
    props.$isLoading &&
    css`
      background-color: ${props.theme.color[buttonThemes[props.$themeColor].background.hover]};
      cursor: wait !important;
      color: transparent !important;

      &:active {
        pointer-events: none;
      }
    `}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.2;

    &:active {
      pointer-events: none;
    }
  }
`;
